"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tanhDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var tanhDependencies = exports.tanhDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createTanh: _factoriesAny.createTanh
};